module.exports = __webpack_public_path__ + "img/bi.cf790c09.svg";